(function() {
  var SECTION_SELECTOR = '[data-faq-section]';
  var ITEM_SELECTOR = '[data-faq-item]';
  var SUMMARY_SELECTOR = '[data-faq-summary]';
  var PANEL_SELECTOR = '[data-faq-panel]';
  var ICON_LINE_SELECTOR = '.faq-item__icon-line--vertical';
  var SECTION_BOUND_ATTR = 'data-faq-bound';
  var ANIMATING_ATTR = 'data-animating';
  var ICON_ANIMATION_ATTR = 'data-icon-animation';
  var ICON_STATE_ATTR = 'data-icon-state';
  var ANSWER_STATE_ATTR = 'data-answer-state';

  function schedule(callback) {
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(callback);
      return;
    }

    setTimeout(callback, 16);
  }

  function toMilliseconds(value) {
    var parsed = parseFloat(value);

    if (isNaN(parsed)) {
      return 0;
    }

    if (value.indexOf('ms') > -1) {
      return parsed;
    }

    return parsed * 1000;
  }

  function getTransitionDuration(element) {
    if (!element || typeof window.getComputedStyle !== 'function') {
      return 0;
    }

    var styles = window.getComputedStyle(element);
    var durations = styles.transitionDuration ? styles.transitionDuration.split(',') : [];
    var delays = styles.transitionDelay ? styles.transitionDelay.split(',') : [];
    var maxDuration = 0;
    var itemCount = Math.max(durations.length, delays.length);

    for (var index = 0; index < itemCount; index++) {
      var duration = toMilliseconds(durations[index] || durations[durations.length - 1] || '0s');
      var delay = toMilliseconds(delays[index] || delays[delays.length - 1] || '0s');
      var total = duration + delay;

      if (total > maxDuration) {
        maxDuration = total;
      }
    }

    return maxDuration;
  }

  function afterTransition(element, propertyName, callback) {
    if (typeof callback !== 'function') {
      return;
    }

    if (!element) {
      callback();
      return;
    }

    var finished = false;
    var timeoutId = null;
    var duration = getTransitionDuration(element);

    function complete(event) {
      if (finished) {
        return;
      }

      if (event && propertyName && event.propertyName !== propertyName) {
        return;
      }

      finished = true;
      element.removeEventListener('transitionend', complete);

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      callback();
    }

    if (!duration) {
      complete();
      return;
    }

    timeoutId = setTimeout(complete, duration + 50);
    element.addEventListener('transitionend', complete);
  }

  function prefersReducedMotion() {
    return (
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function getSummary(item) {
    return item ? item.querySelector(SUMMARY_SELECTOR) : null;
  }

  function getPanel(item) {
    return item ? item.querySelector(PANEL_SELECTOR) : null;
  }

  function setSummaryExpanded(item, expanded) {
    var summary = getSummary(item);

    if (summary) {
      summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
  }

  function setPanelHidden(panel, hidden) {
    if (panel) {
      panel.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    }
  }

  function setAnswerState(item, state) {
    if (item) {
      item.setAttribute(ANSWER_STATE_ATTR, state);
    }
  }

  function syncItem(item) {
    var panel = getPanel(item);
    var isOpen = item.hasAttribute('open');

    item.removeAttribute(ANIMATING_ATTR);
    item.removeAttribute(ICON_ANIMATION_ATTR);
    item.setAttribute(ICON_STATE_ATTR, isOpen ? 'minus' : 'plus');
    setAnswerState(item, isOpen ? 'revealed' : 'hidden');
    setSummaryExpanded(item, isOpen);
    setPanelHidden(panel, !isOpen);

    if (panel) {
      panel.style.overflow = 'hidden';
      panel.style.height = isOpen ? 'auto' : '0px';
    }
  }

  function toggleWithoutAnimation(item) {
    var panel = getPanel(item);
    var willOpen = !item.hasAttribute('open');

    if (willOpen) {
      item.setAttribute('open', '');
    } else {
      item.removeAttribute('open');
    }

    item.setAttribute(ICON_STATE_ATTR, willOpen ? 'minus' : 'plus');
    setAnswerState(item, willOpen ? 'revealed' : 'hidden');
    setSummaryExpanded(item, willOpen);
    setPanelHidden(panel, !willOpen);

    if (panel) {
      panel.style.height = willOpen ? 'auto' : '0px';
    }
  }

  function finishOpen(item, panel) {
    if (!item || !item.isConnected) {
      return;
    }

    panel.style.height = 'auto';
    item.removeAttribute(ANIMATING_ATTR);
    item.setAttribute(ICON_STATE_ATTR, 'minus');
    setAnswerState(item, 'revealed');
    setSummaryExpanded(item, true);
    setPanelHidden(panel, false);
  }

  function finishClose(item, panel) {
    if (!item || !item.isConnected) {
      return;
    }

    item.removeAttribute('open');
    panel.style.height = '0px';
    item.removeAttribute(ANIMATING_ATTR);
    item.setAttribute(ICON_STATE_ATTR, 'plus');
    setAnswerState(item, 'hidden');
    setSummaryExpanded(item, false);
    setPanelHidden(panel, true);
  }

  function completeIconAnimation(item, state, nextIconState) {
    if (!item || !item.isConnected) {
      return;
    }

    if (item.getAttribute(ICON_ANIMATION_ATTR) === state) {
      item.setAttribute(ICON_STATE_ATTR, nextIconState);
      item.removeAttribute(ICON_ANIMATION_ATTR);
    }
  }

  function openItem(item) {
    var panel = getPanel(item);
    var iconLine = item.querySelector(ICON_LINE_SELECTOR);

    if (!panel) {
      toggleWithoutAnimation(item);
      return;
    }

    item.setAttribute(ANIMATING_ATTR, 'true');
    item.setAttribute(ICON_ANIMATION_ATTR, 'opening');
    item.setAttribute('open', '');
    setSummaryExpanded(item, true);
    setPanelHidden(panel, false);
    setAnswerState(item, 'hidden');
    panel.style.overflow = 'hidden';
    panel.style.height = '0px';

    var panelTargetHeight = panel.scrollHeight;
    panel.getBoundingClientRect();

    schedule(function() {
      setAnswerState(item, 'revealed');
      panel.style.height = panelTargetHeight + 'px';
    });

    afterTransition(iconLine, 'transform', function() {
      completeIconAnimation(item, 'opening', 'minus');
    });

    afterTransition(panel, 'height', function() {
      if (!item || !item.isConnected || !item.hasAttribute('open')) {
        return;
      }

      finishOpen(item, panel);
    });
  }

  function closeItem(item) {
    var panel = getPanel(item);
    var iconLine = item.querySelector(ICON_LINE_SELECTOR);

    if (!panel) {
      toggleWithoutAnimation(item);
      return;
    }

    var currentHeight = panel.getBoundingClientRect().height;

    item.setAttribute(ANIMATING_ATTR, 'true');
    item.setAttribute(ICON_ANIMATION_ATTR, 'closing');
    setSummaryExpanded(item, false);
    setPanelHidden(panel, false);
    setAnswerState(item, 'revealed');
    panel.style.overflow = 'hidden';

    if (currentHeight <= 0) {
      completeIconAnimation(item, 'closing', 'plus');
      finishClose(item, panel);
      return;
    }

    panel.style.height = Math.round(currentHeight) + 'px';
    panel.getBoundingClientRect();

    schedule(function() {
      setAnswerState(item, 'hidden');
      panel.style.height = '0px';
    });

    afterTransition(iconLine, 'transform', function() {
      completeIconAnimation(item, 'closing', 'plus');
    });

    afterTransition(panel, 'height', function() {
      finishClose(item, panel);
    });
  }

  function onSummaryClick(event) {
    var summary = event.currentTarget;
    var item = summary.closest(ITEM_SELECTOR);

    if (!item) {
      return;
    }

    event.preventDefault();

    if (item.getAttribute(ANIMATING_ATTR) === 'true') {
      return;
    }

    if (prefersReducedMotion()) {
      toggleWithoutAnimation(item);
      return;
    }

    if (item.hasAttribute('open')) {
      closeItem(item);
      return;
    }

    openItem(item);
  }

  function bindSection(section) {
    if (!section || section.getAttribute(SECTION_BOUND_ATTR) === 'true') {
      return;
    }

    section.setAttribute(SECTION_BOUND_ATTR, 'true');

    var items = section.querySelectorAll(ITEM_SELECTOR);
    var summaries = section.querySelectorAll(SUMMARY_SELECTOR);
    var index = 0;

    for (index = 0; index < items.length; index++) {
      syncItem(items[index]);
    }

    for (index = 0; index < summaries.length; index++) {
      if (summaries[index].__faqBound) {
        continue;
      }

      summaries[index].addEventListener('click', onSummaryClick);
      summaries[index].__faqBound = true;
    }
  }

  function initSections(root) {
    var scope = root || document;
    var sections = [];
    var index = 0;

    if (scope.matches && scope.matches(SECTION_SELECTOR)) {
      sections = [scope];
    } else {
      sections = scope.querySelectorAll(SECTION_SELECTOR);
    }

    for (index = 0; index < sections.length; index++) {
      bindSection(sections[index]);
    }
  }

  function onReady() {
    initSections(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    schedule(onReady);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initSections(event.target);
  });
})();
